<template>
  <div class="relative mb-16 lg:mb-24" :class="background">
    <VcImage
      v-if="ctaImage"
      :src="ctaImage"
      :alt="imageDescription"
      class="h-full max-h-[600px] w-full object-cover"
      lazy
    />

    <div
      class="w-full bg-[color:var(--color-header-bottom-bg)] md:mx-auto md:max-w-[670px] md:rounded-l-lg"
      :class="ctaImage ? 'md:absolute right-0 top-[50%] md:translate-y-[-50%]' : ''"
    >
      <div class="flex flex-col p-8 md:p-12">
        <h2 v-if="title" class="mb-8 text-4xl font-semibold" :class="textColor ? textColor : 'text-white'">
          {{ title }}
        </h2>
        <div
          v-if="subtitle"
          class="heras-cta-text mb-6 text-lg"
          :class="textColor ? textColor : 'text-white'"
          v-html-safe="sanitizedSubtitle"
        ></div>
        <VcButton
          v-if="showTheButton"
          :to="buttonLink"
          size="lg"
          variant="no-background"
          color="white"
          append-icon="arrow-right"
          class="w-fit"
        >
          {{ buttonLabel }}
        </VcButton>
        <div v-if="buttons && buttons.length" class="flex w-full items-center justify-start space-x-6">
          <VcButton
            v-for="(item, index) in buttons"
            :key="index"
            v-bind="getLinkAttr(item.link)"
            class="min-w-20 w-1/2 px-8 lg:w-auto"
            variant="no-background"
            size="lg"
            color="white"
          >
            {{ item.label }}
          </VcButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";
import { marked } from "marked";
import { markdownHtmlSanitizeOptions } from "@/core/utilities/sanitize";
import sanitizeHtml from "sanitize-html";

type ButtonType = {
  label: string;
  link: string;
};

type ContentType = {
  html: string;
  markdown: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  ctaImage?: string;
  imageDescription?: string;
  title?: string;
  subtitle?: ContentType;
  buttons?: Array<ButtonType>;
  buttonLink?: string;
  buttonLabel?: string;
}

const props = defineProps<IProps>();

const sanitizedSubtitle = computed(() =>
  sanitizeHtml(marked(props.subtitle?.html || props.subtitle?.markdown || "") as string, markdownHtmlSanitizeOptions),
); // accepting basic html tags, but no scripts or event handlers, to prevent XSS vulnerabilities);

const showTheButton = computed(() => {
  return Boolean(props.buttonLink) && Boolean(props.buttonLabel);
});
</script>

<style>
.heras-cta-text p {
  @apply font-light;
}
</style>
